import React, { useState, useEffect } from 'react';
import { styles } from './styles';
import Table from './Table';

const Subscription = () => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [postcode, setPostcode] = useState('');
  const [frequency, setFrequency] = useState('');
  const [amount, setAmount] = useState('');
  const [subscriptions, setSubscriptions] = useState([]);
  const [searchEmail, setSearchEmail] = useState('');
  const [filteredSubscriptions, setFilteredSubscriptions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const subscriptionsPerPage = 5;

  // Load subscriptions from localStorage when the component mounts
  useEffect(() => {
    const storedSubscriptions = JSON.parse(localStorage.getItem('subscriptions')) || [];
    setSubscriptions(storedSubscriptions);
    updateFilteredSubscriptions(storedSubscriptions, searchEmail);
  }, []);

  const handleAddSubscription = () => {
    const newSubscription = {
      fullName,
      email,
      phone,
      postcode,
      frequency,
      amount,
    };
    const updatedSubscriptions = [...subscriptions, newSubscription];
    setSubscriptions(updatedSubscriptions);
    updateFilteredSubscriptions(updatedSubscriptions, searchEmail);
    // Save updated subscriptions to localStorage
    localStorage.setItem('subscriptions', JSON.stringify(updatedSubscriptions));
    // Clear form fields after adding subscription
    setFullName('');
    setEmail('');
    setPhone('');
    setPostcode('');
    setFrequency('');
    setAmount('');
    setCurrentPage(Math.ceil(updatedSubscriptions.length / subscriptionsPerPage)); // Move to the last page
  };

  const handleSearch = () => {
    updateFilteredSubscriptions(subscriptions, searchEmail);
  };

  const updateFilteredSubscriptions = (subscriptions, searchEmail) => {
    const filtered = subscriptions.filter(subscription =>
      subscription.email.toLowerCase().includes(searchEmail.toLowerCase())
    );
    setFilteredSubscriptions(filtered);
  };

  useEffect(() => {
    updateFilteredSubscriptions(subscriptions, searchEmail);
  }, [subscriptions, searchEmail]);

  // Calculate the current subscriptions to display
  const indexOfLastSubscription = currentPage * subscriptionsPerPage;
  const indexOfFirstSubscription = indexOfLastSubscription - subscriptionsPerPage;
  const currentSubscriptions = filteredSubscriptions.slice(indexOfFirstSubscription, indexOfLastSubscription);

  const totalPages = Math.ceil(filteredSubscriptions.length / subscriptionsPerPage);

  return (
    <div className='p-0 m-0 box-border'>
      <div className='w-[98%] mx-auto px-6 py-8 bg-white rounded-xl'>
        <div className='flex flex-col sm:flex-row justify-between items-center p-2'>
          <div className='w-full sm:w-120 text-4xl font-semibold text-blue-700 mb-4 sm:mb-0' style={styles.interText}>
            Subscription for DMP
          </div>
          <div className='flex w-full sm:w-auto items-center px-2 border border-gray-700 border-opacity-50 rounded-md'>
            <div className='flex items-center w-full py-2 px-3'>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" className='w-5 h-5 mr-2'>
                <path fill="none" stroke="#1369B6" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m16.893 16.92l3.08 3.08m-.889-8.419c0 4.187-3.383 7.581-7.555 7.581c-4.173 0-7.556-3.394-7.556-7.58C3.973 7.393 7.356 4 11.528 4c4.173 0 7.556 3.394 7.556 7.581" />
              </svg>
              <input
                type='text'
                placeholder='Search by email'
                value={searchEmail}
                onChange={(e) => setSearchEmail(e.target.value)}
                className='h-full w-full px-4 py-2 text-sm font-medium text-blue-700 bg-white border-none rounded-l-md'
                style={styles.robotoText}
              />
              <button
                className='h-full px-4 py-2 text-sm font-medium text-white bg-blue-700 rounded-r-md'
                onClick={handleSearch}
              >
                Search
              </button>
            </div>
          </div>
        </div>

        {/* Form Inputs */}
        <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4'>
          <input
            type='text'
            placeholder='Full Name'
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            className='p-2 border border-gray-300 rounded-md w-full'
          />
          <input
            type='text'
            placeholder='Email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className='p-2 border border-gray-300 rounded-md w-full'
          />
          <input
            type='text'
            placeholder='Phone'
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className='p-2 border border-gray-300 rounded-md w-full'
          />
          <input
            type='text'
            placeholder='Postcode'
            value={postcode}
            onChange={(e) => setPostcode(e.target.value)}
            className='p-2 border border-gray-300 rounded-md w-full'
          />
          <input
            type='text'
            placeholder='Frequency'
            value={frequency}
            onChange={(e) => setFrequency(e.target.value)}
            className='p-2 border border-gray-300 rounded-md w-full'
          />
          <input
            type='text'
            placeholder='Amount'
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            className='p-2 border border-gray-300 rounded-md w-full'
          />
        </div>

        {/* Add Button */}
        <div className='flex justify-end mt-4'>
          <button
            onClick={handleAddSubscription}
            className='px-4 py-2 bg-blue-700 text-white rounded-md font-semibold hover:bg-blue-600'
          >
            Add
          </button>
        </div>

        {/* Display Table */}
        <Table subscriptions={currentSubscriptions} />

        {/* Pagination */}
        <div className='flex justify-end mt-4'>
          <button
            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
            className='px-4 py-2 mx-1 bg-blue-700 text-white rounded-md font-semibold hover:bg-blue-600'
          >
            Previous
          </button>
          <button
            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
            className='px-4 py-2 mx-1 bg-blue-700 text-white rounded-md font-semibold hover:bg-blue-600'
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Subscription;